module.exports = __webpack_public_path__ + "media/audio23.0db5550c.mp3";